import React, { FC } from 'react'
import { situationMonegasque } from './Options'
import MySelect from '../formGroup/MySelect'
import { useTriggerChangeHook } from '../../hooks/triggerChangeHook'
import { IStep5SituationMonegasque } from '../../interfaces/Step5'
import { getItemSuffix } from '../../utils/getItemSuffix'

const Step5SituationMonegasque: FC<IStep5SituationMonegasque> = ({
  register,
  error,
  item,
}) => {
  const situationMonegasqueSuffix = `situation_monegasque${getItemSuffix(item)}`
  const situation_monegasque = useTriggerChangeHook(situationMonegasqueSuffix)

  return (
    <MySelect
      options={situationMonegasque}
      value={situation_monegasque || ''}
      register={register}
      name={situationMonegasqueSuffix}
      id={situationMonegasqueSuffix}
      error={error}
      label="Situation"
      required
      className="col12 colLg6 colXl4"
    />
  )
}

export default Step5SituationMonegasque
